// ############################ Require packages here ############################
import React, { lazy, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Aos from 'aos';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// ############################ Require files here ###############################

import ScheduleForm from '../scheduleForm';
// import TestimonialSlider from '../testimonialSlider';
import RelatedResources from '../relatedResources';
import { getOneResource } from '../../../Redux/ActionCreators/resourcesAction';
const TestimonialSlider = lazy(() => import("../testimonialSlider"));

export default function Spotlight5() {

    useEffect(() => {
        Aos.init({ duration: 2000 })
    }, [])


    const navigate = useNavigate();
    const dispatch = useDispatch();

    const setPage = (val) => {
        window.scrollTo(0, 0);
        if (val === 'contact') {
            window.scrollTo(0, 2500);
        } else if (val === 'resources') {
            navigate('/resources-hub')
        }
    }

    const downloadFactsheet = async () => {
        const res = await dispatch(getOneResource(['6874f17073e7c96684556880']))
        if (res?.type === 'GET_ONE_RESOURCES') {
            navigate(`/resources/factsheet/${encodeURIComponent(res.payload?.title)}`, { state: { data: res?.payload } })
        }
    }


    return (
        <div className='seq-content-page'>
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <meta charSet="utf-8" />
                <title>From Policy to Posture: Not Just Covered on Paper</title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
                <meta name="description" content="Explore The Qut Episode 5 podcast as Pankit Desai and Mrinmoy Jana unpack the insurance sector, moving from paper compliance to actual security posture, and how Mythos AI is transforming risk and resilience across the BFSI landscape." />
                <meta name="keywords" content="Insurance, Cyber Insurance, BFSI, Policy, Posture, Compliance, Risk, Resilience, Protection, Innovation, Security, Mythos AI, Artificial Intelligence, Cybersecurity, Governance, Threats, Vulnerability, Automation, Finance, Underwriting, Strategy, Podcast, The Qut, Defense, Risk Management, Pankit Desai, Mrinmoy Jana, Sequretek, Zuno General Insurance, IRDAI, insurance sector cybersecurity, BFSI cyber risk, moving from policy to posture, cyber insurance compliance, Mythos AI in finance, AI-driven risk management, BFSI operational resilience, insurance cybersecurity podcast, The Qut Episode 5, paper compliance vs actual security, cyber posture insurance industry, Mythos AI BFSI sector, financial sector cyber threats, smart insurance technology, banking and finance cyber protection, regulatory compliance insurance sector, business continuity BFSI, cyber maturity insurance, podcast on insurance cybersecurity, cyber risk insights for BFSI, insurance compliance podcast, cyber resilience strategies for financial industry, The Qut Episode 5 podcast highlights, how insurance companies manage cyber threats, AI in cyber underwriting, proactive security posture BFSI, Pankit Desai podcast, Mrinmoy Jana CISO, Zuno General Insurance cybersecurity, Sequretek podcast, IRDAI cyber security guidelines insurance, data protection insurance sector India" />
                <meta property="og:title" content="The Qut Episode 5 Podcast | From Policy to Posture: Not Just Covered on Paper" />
                <meta property="og:description" content="Explore The Qut Episode 5 podcast as Pankit Desai and Mrinmoy Jana unpack the insurance sector, moving from paper compliance to actual security posture, and how Mythos AI is transforming risk and resilience across the BFSI landscape." />
            </Helmet>
            {/* section 1 BANNER */}
            <div className='seq-content-heading' style={{ backgroundImage: `url('/images/Spotlight5-banner.svg')` }}>
                <div className='seq-description'>
                    <h2 data-aos="fade-up">
                        <p style={{ fontSize: "36px", color: " #A2DAE0" }}>The Qut - Episode 5</p>
                        From Policy to Posture: Not Just Covered on Paper
                    </h2>
                    <div data-aos="fade-up" className='text-center mt-3'>
                        <button onClick={() => downloadFactsheet()} class="ext-btn">Download Case Study</button>
                        <button onClick={() =>
                            window.open(
                                "https://share-na2.hsforms.com/1b5KHf-18R6OB9rRgHh4miwqlq08",
                                "_blank",
                                "noopener,noreferrer"
                            )
                        } >Register Now</button>
                    </div>
                </div>
            </div>
            {/* section 2 INFO */}
            <div className='seq-content-1'>
                <div className='container pe-0'>
                    <div className='row me-0'>
                        <div className='col-md-5 col-sm-12 col-12'>
                            <h4>
                                <img src='/images/spotlight5_icon.svg' alt='' height={60} loading="lazy" />
                                <br />
                                The AI Threat Multiplier: Chained Exploitation in Modern Insurance Security
                            </h4>
                        </div>
                        <div className='col-md-6 col-sm-12 offset-lg-1 col-12 seq-info-text'>
                           <p>The insurance world is entering a new digital era, driven by hyper-automation, cloud platforms, and the integration of Mythos AI. While efficiency and risk assessment capabilities have never been higher, this rapid progress brings a new, deeply complex kind of exposure.</p><br />
                           <p>In the BFSI sector, severe tool sprawl and sophisticated chained exploitation, often supercharged by AI. Meaning that being "covered on paper" is no longer enough to survive modern cyber threats.</p><br />
                           <p>To make sense of this shifting landscape, The Qut brings together two experts to deliver clarity amid complexity.</p>
                           <p>In this episode, <a href="https://www.linkedin.com/in/mrinmoy-jana-8a635618/">Mrinmoy Jana</a>, CISO, Zuno General Insurance and <a href="https://www.linkedin.com/in/pankit/">Pankit Desai</a>, CEO & Co-Founder, <a href="https://www.linkedin.com/company/sequretek">Sequretek</a> chart the route through critical checkpoints shaping modern infrastructure, exploring how the sector must transition from mere policy alignment to a proactive security posture.</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* section 3 CHALLENGES */}
            <div className="seq-content-1">
                <div className="container pe-0">
                    <div className="row me-0 justify-content-center">

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/sp-Compliance.svg" alt="Compliance" height={40} />
                            <h4>Risk</h4>
                            <p style={{ textAlign: "center" }}>
                                Eliminate tool sprawl blindspots and learn to break complex, AI-driven chained exploitations before they disrupt your infrastructure.
                            </p>
                        </div>

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/sp-Risk.svg" alt="Risk" height={40} />
                            <h4>Compliance</h4>
                            <p style={{ textAlign: "center" }}>
                                Move beyond rigid paper compliance and discover how active security posture turns IRDAI and data regulations into a strategic shield.
                            </p>
                        </div>

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/Resilience.svg" alt="Continuity" height={40} />
                            <h4>Resilience</h4>
                            <p style={{ textAlign: "center" }}>
                                Explore how unified visibility and proactive governance keep insurance workflows running seamlessly during disruptions.
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            {/* section 6 */}
            <div className='seq-how-to-helps' style={{ backgroundImage: `url('/images/spotlight_para.svg')`, backgroundSize: "cover" }}>
                <div className='container'>
                    <div className='seq-help-bg'>
                        <div className='row '>
                            <div data-aos="fade-up" className=' col-md-5 col-12 seq-help-left'>
                                <p>How Sequretek Helps</p>
                                <h3>Navigate Cyber Risk with Confidence Through Sequretek’s Integrated Security Platform</h3>
                                <button onClick={() => setPage('contact')}>Get started</button>
                            </div>
                            {window.innerWidth > 767 ?
                                <div className='col-md-4  offset-md-1 seq-ind-qimg'>
                                    <img src='/images/q-icon1.svg' alt='' height={300} loading="lazy" />
                                </div> :
                                null
                            }
                        </div>
                    </div>

                </div>
            </div>
            {/* section 5 */}
            <div className='seq-content-1'>
                <div className='container pe-0'>
                    <div className='row me-0'>
                        <div className='col-md-5 col-sm-12 col-12'>
                            <img src='/images/The Qut - Episode 5.png' style={{ width: "500px !important;" }} alt='' loading="lazy" />
                        </div>
                        <div className='col-md-6 col-sm-12 offset-lg-1 col-12 seq-info-text'>
                            <h4>Plainspeak Drives Real Action</h4><br />
                            <p>The Qut is our platform to spotlight critical conversations with leaders solving real security challenges. No fluff, just insight. </p>
                            <p style={{ marginTop: "15px" }}>This executive exchange aims to help you rethink your cybersecurity posture and leadership approach in an increasingly digitized automotive industry.</p>
                            <button onClick={() =>
                                window.open(
                                    "https://share-na2.hsforms.com/1b5KHf-18R6OB9rRgHh4miwqlq08",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            } className='reserve-btn'>Register Now</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* section 7 SCHEDULE DEMO FORM */}
            <div className='seq-forms'>
                <div className='container ps-4 pe-4 '>
                    <div className='col-md-12 col-sm-12 col-12  seq-info-text'>
                        <h4 className='heading_k'>How can we help improve your security posture? Let’s talk!</h4>
                    </div>
                    <div className="insurance-partseven" data-aos="fade-up">
                        <ScheduleForm
                            text={'The security of your data and infrastructure is more critical than ever. Secure your sensitive data with Sequretek’s enhanced security monitoring and threat detection and ensure that your critical information remains confidential and protected.'}
                            bg={'/images/bg-img74.svg'}
                            mobilebg={'/images/bg-img71.svg'}
                            page='banking'
                        />
                    </div>
                </div>
            </div>
            {/* section 7 RELATED RESOURCES */}
            <div className='seq-resources'>
                <div className='container'>
                    <h4>Related resources</h4>
                    <div className='row ms-0 me-0'>
                        <div className='col-md-12 ps-0'>
                            <div className={window.innerWidth > 767 ? 'row ' : 'row flex-nowrap overflow-auto'}>
                                <RelatedResources
                                    page='resources'
                                    type='Case Studies'
                                    title='Throwing light on the many attack surfaces and leaving no device unturned'
                                />
                                <RelatedResources
                                    page='resources'
                                    type='Case Studies'
                                    title='Throwing light on the many attack surfaces and leaving no device unturned'
                                />
                                <RelatedResources
                                    page='resources'
                                    type='Infographics'
                                    title='Manufacturing at the Crossroads'
                                />
                                <RelatedResources
                                    page='resources'
                                    type='Podcasts'
                                    title='The Qut - Episode 1 - Driving Automotive Cyber Resilience - Compliance, Risk and Continuity'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {window.innerWidth > 767 ? <div className='d-flex align-items-center justify-content-center' style={{ background: '#040c30' }}><button className='seq-resource-btn' onClick={() => setPage('resources')}>Visit the resource center</button></div> : <div className='d-flex align-items-center justify-content-center' style={{ background: '#040c30' }}><button className='seq-resource-btn' onClick={() => setPage('resources')}>Resource Center</button></div>}
        </div>
    )
}
